import { Box, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { memo } from 'react';
import util from '../../util/index';

const maxTopLimit= 11;
const Thermometer = ({ title, minValue, maxValue, lowerLimit, upperLimit, unit, hideUpperLimitText = false, hideMaxLimitText = false, upperLimitText = '', maxLimitText = '', minLimitText = '', lowerLimitText = '' }) => {
       const theme = useTheme()
        let maxRange = maxValue > upperLimit ? maxValue + 5 : upperLimit + 5;
        //special case
        if (maxRange < lowerLimit) {
            maxRange = lowerLimit + 5;
        }
        let minRange = 0;
        if (minValue !== 0 || lowerLimit !== 0) {
            minRange = minValue > lowerLimit ? lowerLimit - 15 : minValue - 15;
        }

        //special case
        if (minRange > upperLimit) {
            minRange = upperLimit - 15;
        }
        let lowerLimitPercentage = lowerLimit === 0 ? 0 : util.calculatePercentage(maxRange - minRange, lowerLimit - minRange) - 10;
        let upperLimitPercentage = upperLimit === 0 ? 0 : util.calculatePercentage(maxRange - minRange, upperLimit - minRange) - 10;
        let minValuePercentage = minValue === 0 ? 0 : util.calculatePercentage(maxRange - minRange, minValue - minRange) - 10;
        let maxValuePercentage = maxValue === 0 ? 0 : util.calculatePercentage(maxRange - minRange, maxValue - minRange) - 10;
        let differenceUpperLowerPercentage = (upperLimit === 0 ? 90 : upperLimitPercentage) - lowerLimitPercentage;
        let differenceMinMaxPercentage = maxValuePercentage - minValuePercentage;
		const upperLimitLabel = upperLimitText || `${upperLimit} ${unit}`;
		const lowerLimitLabel = lowerLimitText || `${lowerLimit} ${unit}`;
		const maxLimitLabel= maxLimitText || `Max (${maxValue}) ${unit}`;
		const minLimitLabel = minLimitText || `Min (${minValue}) ${unit}`;
		const maxBarCalcValue = 100 - maxValuePercentage + differenceMinMaxPercentage;
		const maxBarTopValue = maxBarCalcValue <= maxTopLimit ? maxTopLimit : maxBarCalcValue;
        return (
			<Box>
				<Typography textAlign={'center'} fontWeight={'bold'} variant="body2" gutterBottom>
					{title}
				</Typography>
				<Box
					sx={{
						position: 'relative',
						fontSize: 10,
						lineHeight: 1,
						'& span.MuiTypography-root': {
							position: 'absolute'
						},
						'& .MuiDivider-root.MuiDivider-fullWidth': {
							width: 60
						}
					}}
					className="custom-outer"
				>
					<Box className="custom-inner">
						{!hideUpperLimitText && <Box className="dashed-line" sx={{ top: 102 - upperLimitPercentage + '%' }}>
							<Divider backgroundcolor="transparent" />
							<Typography
								component="span"
								lineHeight={'inherit'}
								fontSize={'inherit'}
								sx={{ top: -12, left: 55 }}
							>
								{upperLimitLabel}
							</Typography>
						</Box>}
						{!hideMaxLimitText &&<Box className="line" sx={{ top: 100 - maxValuePercentage + '%', left: '-42%' }}>
							<Divider backgroundColor="primary.main" />
							<Typography
								component="span"
								fontSize={'inherit'}
								lineHeight={'inherit'}
								sx={{ top: -10, left: -53 }}
							>
								{maxLimitLabel} 
							</Typography>
						</Box>}
						<Box
							className="line"
							sx={{ top: maxBarTopValue + '%', left: '-42%' }}
						>
							<Divider backgroundcolor="primary.main" />
							<Typography
								component="span"
								fontSize={'inherit'}
								lineHeight={'inherit'}
								sx={{ top: -2, left: -53 }}
							>
							 {minLimitLabel} 
							</Typography>
						</Box>
						<Box className="dashed-line" style={{ top: 100 - lowerLimitPercentage + '%' }}>
							<Divider backgroundcolor="primary.main" />
							<Typography
								component="span"
								fontSize={'inherit'}
								lineHeight={'inherit'}
								sx={{ top: -1, left: 55 }}
							>
								{lowerLimitLabel}
							</Typography>
						</Box>
						<Box className="custom-thermometer-first"></Box>
						<Box
							className="custom-thermometer"
							sx={{
								height: upperLimit === 0 ? 0 : 90 - upperLimitPercentage + '%',
								backgroundColor: theme.palette.error.light
							}}
						/>
						<Box
							className="custom-thermometer"
							sx={{
								height: differenceUpperLowerPercentage + '%',
								backgroundColor: theme.palette.success.light
							}}
						/>
						<Box
							className="custom-thermometer"
							sx={{ height: lowerLimitPercentage + '%', backgroundColor: theme.palette.error.light }}
						/>
					</Box>
					<Box
						className="custom-thermometer-bottom"
						style={{ height: 50, width: 50, backgroundColor: theme.palette.error.light, borderRadius: 9999 }}
					/>
				</Box>
			</Box>
		);
    
}

export default memo(Thermometer);